import './MultiColumnB.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { MultiColumnBContentType } from './contentTypes';

export const MultiColumnB = ({ columns, options }: MultiColumnBContentType) => {
  const _headingType = columns?.options?.headingType as string;
  const _rowClassName = `before-${columns?.options?.ordering}`;

  return (
    <ComponentWrapper
      classNames="multi-column-b"
      options={{ ...options, container: { enabled: true, size: 'always' } }}
    >
      <b2x.Row alignItems={'center'} className={_rowClassName}>
        {columns?.asset?.asset && (
          <b2x.Col className="asset-column" size={{ lg: 6, xs: 12 }}>
            <b2x.AssetV2 {...columns.asset.asset} />
          </b2x.Col>
        )}
        {(columns?.content?.title || columns?.content?.content || columns?.content?.cta) && (
          <b2x.Col className="content-column" size={{ lg: 6, xs: 12 }}>
            <b2x.Div className="inner-container" display={'flex'} flexDirection={'column'} gap={{ lg: 4, xs: 3 }}>
              {columns.content.title &&
                React.createElement(
                  _headingType,
                  { class: 'h1 m-0' },
                  b2x.formatHtml(columns.content.title.toUpperCase())
                )}
              {columns.content.content && (
                <b2x.Div className="h3 m-0">{b2x.formatHtml(columns.content.content)}</b2x.Div>
              )}
              {columns.content.cta && (
                <b2x.Div>
                  <b2x.CtaFromContent
                    {...columns.content.cta}
                    variant={columns.content.cta.variant !== '' ? columns.content.cta.variant : 'primary'}
                  />
                </b2x.Div>
              )}
            </b2x.Div>
          </b2x.Col>
        )}
      </b2x.Row>
    </ComponentWrapper>
  );
};
